import React from 'react';
import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { Flex } from '@qga/roo-ui/components';
import { themeGet } from 'styled-system';

import PackageOptionContent from '../PackageOptionContent';
import Pill, { StyledPill } from '../PackageOptionPill';
import Tick, { StyledTick } from '../PackageOptionTick';

const StyledPackageOption = styled(Flex)`
  position: relative;
  isolation: isolate;
`;

// Adds border around selected card ON TOP of pill
const getSelectedBorder = (props: any) => css`
  &::after {
    content: '';
    inset: 0;
    border-color: ${themeGet('components.packageOption.selected.borderColor')(
      props,
    )};
    border-width: ${themeGet('components.packageOption.borderWidth')(props)};
    border-radius: ${themeGet('components.packageOption.borderRadius')(props)};
    border-style: solid;
    position: absolute;
    z-index: 2;
    pointer-events: none;
  }
`;

const StyledPackageOptionCard = styled.div<{ selected?: boolean }>`
  position: relative;
  display: flex;
  isolation: isolate;

  ${({ selected, ...themeProps }) => selected && getSelectedBorder(themeProps)};

  ${StyledPill} {
    z-index: 1;
    overflow: hidden;
    border-top-left-radius: 8px;
  }

  ${StyledTick} {
    z-index: 3;
    color: ${themeGet('components.packageOption.selected.borderColor')};
  }

  ${PackageOptionContent} {
    padding: 0 ${themeGet('components.packageOption.padding')};
  }
`;

interface Props {
  children?: React.ReactNode;
  selected?: boolean;
  pillText: string | null;
  testId?: string;
}

const PackageOptionCard = ({ selected, pillText, children }: Props) => (
  <StyledPackageOptionCard
    selected={selected}
    data-testid="PACKAGE_OPTION_CARD"
  >
    {pillText && <Pill message={pillText} icon={'schedule'} />}
    {selected && <Tick />}
    {children && (
      <StyledPackageOption data-testid="PACKAGE_OPTION_CONTENT">
        {children}
      </StyledPackageOption>
    )}
  </StyledPackageOptionCard>
);

export default PackageOptionCard;
